
import { defineComponent } from "vue";
import { mapGetters } from "vuex";
import { sortableColumns } from "@/store/MyTeam/MyTeamInterfaces";

export default defineComponent({
  name: "my-team-sort-pills",
  emits: ["updateSortConfiguration"],
  computed: {
    ...mapGetters("myTeam", {
      getSortConfiguration: "getSortConfiguration",
    }),
  },
  methods: {
    /**
     * El icono que va DENTRO de la pastilla y que, al pulsarlo, le da la vuelta
     * a la dirección de esa columna.
     *
     * ⚠️ AQUÍ FALTABAN TRES COLUMNAS —«Paquete», «Días Subscripción» y «Días
     * Distribuidor»— y el `default` les devolvía cadena vacía. Un `<i>` sin
     * clase de FontAwesome no pinta ningún glifo, así que se quedaba en un
     * elemento de tamaño CERO: invisible y, lo que importa, imposible de pulsar.
     * El resultado es que esas tres columnas se podían ordenar pero no se les
     * podía cambiar el sentido desde la pastilla — había que quitarla y volver a
     * ordenar desde la cabecera. Como no fallaba nada ni salía error, parecía un
     * hueco de diseño en vez de un caso olvidado en un `switch`.
     *
     * El `default` se queda como red de seguridad, pero ya no le llega nada:
     * están cubiertas las quince columnas de `sortableColumns`.
     */
    sortOrderIconClass(
      column: sortableColumns,
      direction: "asc" | "desc"
    ): string {
      switch (column) {
        case "username":
        case "nickname":
        case "unilevel_side":
        case "cmmi_end_date":
          return direction === "asc"
            ? "fas fa-sort-alpha-down ms-2 me-1"
            : "fas fa-sort-alpha-up ms-2 me-1";
        // Rango y paquete comparten icono porque comparten naturaleza: no son
        // ni una cifra ni una palabra, son una ESCALA con sus escalones puestos
        // en un orden que decide el negocio. El icono de «cantidad» dice eso;
        // el de A-Z diría que se ordenan por su nombre, que es justamente el
        // error que se acaba de quitar del paquete.
        case "rank_priority":
        case "current_package":
          return direction === "asc"
            ? "fas fa-sort-amount-down-alt ms-2 me-1"
            : "fas fa-sort-amount-up-alt ms-2 me-1";
        case "downlines":
        case "academy_days_left":
        case "scholarship_points":
        case "license_days_left":
        case "subscription_days_left":
        case "distributor_days_left":
        case "total_volume":
        case "qualified_volume_total":
        case "qualified_percentage_total":
        case "depth":
          return direction === "asc"
            ? "fas fa-sort-numeric-down ms-2 me-1"
            : "fas fa-sort-numeric-up ms-2 me-1";
        default:
          return "";
      }
    },
    getUserFriendlyColumnName(column: sortableColumns): string {
      switch (column) {
        case "username":
          return "Usuario";
        case "nickname":
          return "Nickname";
        case "rank_priority":
          return "Rango";
        case "downlines":
          return "Miembros de Equipo";
        case "academy_days_left":
          return "Academia";
        case "unilevel_side":
          return "Lado";
        case "scholarship_points":
          return "Beca";
        case "license_days_left":
          return "Licencia";
        case "cmmi_end_date":
          return "Acelerador de Riqueza";
        case "total_volume":
          return "Volumen Total";
        case "qualified_volume_total":
          return "Volumen Calificado";
        case "qualified_percentage_total":
          return "Porcentaje Calificado";
        case "depth":
          return "Profundidad";
        case "current_package":
          return "Paquete";
        case "subscription_days_left":
          return "Días Subscripción";
        case "distributor_days_left":
          return "Días Distribuidor";
        default:
          return column;
      }
    },
    updateSortConfiguration(column: string, direction: "asc" | "desc") {
      this.$emit("updateSortConfiguration", column, direction);
    },
  },
});
